export default {
  0: { description: 'Default', window: '1800', level: '800' },
  1: { description: 'Brain', window: '90', level: '35' },
  2: { description: 'Brain Bone', window: '1600', level: '450' },
  3: { description: 'Spine', window: '4000', level: '700' },
  4: { description: 'Lung', window: '1500', level: '-400' },
  5: { description: 'Mediastinum', window: '350', level: '40' },
  6: { description: 'Abdomen', window: '1500', level: '-700' },
  7: { description: 'Liver', window: '400', level: '40' },
  8: { description: 'Bone', window: '1600', level: '550' },
  9: { description: 'Vessel', window: '500', level: '40' },
  // 10: { description: 'Empty4', window: 'Empty4', level: 'Empty4' },
};
